import { enrollFactor } from '@wix/ambassador-identity-factors-v1-identity-factor/http';
import {
  FactorType,
  EnrollFactorResponse,
} from '@wix/ambassador-identity-factors-v1-identity-factor/types';
import { httpClient } from './httpClient';

export class WebAuthnApi {
  public async enrollWebAuthn(
    credential?: Credential,
  ): Promise<EnrollFactorResponse> {
    return httpClient
      .request(
        enrollFactor({
          factorType: FactorType.WEBAUTHN,
          webauthnData: { credential: JSON.stringify(credential) },
        }),
      )
      .then((response) => response.data);
  }
}
